<template>
  <div>
    <div style="display: inline-block;margin-right: 10px">{{userName}}</div>
    <div class="user-avatar-dropdown">
      <Dropdown @on-click="handleClick">

        <Badge :dot="!!messageUnreadCount">
          <Avatar src="https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=2075994595,1810657300&fm=58&bpow=1001&bpoh=955"/>
          <!--<Avatar src="http://macro-oss.oss-cn-shenzhen.aliyuncs.com/mall/images/20180607/timg.jpg"/>-->
          <!--<Avatar :src="userAvatar"/>-->
        </Badge>
        <Icon :size="18" type="md-arrow-dropdown"></Icon>
        <DropdownMenu slot="list">
          <DropdownItem name="message">
            消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
          </DropdownItem>
          <DropdownItem name="editPass">修改密码</DropdownItem>
          <DropdownItem name="logout">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import './user.less';
import {mapActions} from 'vuex';
const global = require('@/global/global');

export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    },
    userName: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut',
      'onLogout'
    ]),
    toLogout() {
      this.onLogout();
    },
    logout() {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: this.LOGIN_PAGE_NAME
        });
      });
      if (this.IMHX_LOGIN) {
        this.onLogout();
      }
    },
    message() {
      this.$router.push({
        name: 'msg_readstatus'
      });
    },
    editPass() {
      this.$router.push({
        name: 'editPassword'
      });
    },
    handleClick(name) {
      switch (name) {
        case 'logout': this.logout();
          break;
        case 'message': this.message();
          break;
        case 'editPass': this.editPass();
          break;
      }
    }
  }
};
</script>
